export default __webpack_public_path__ + "static/media/standing-man.d1949739.svg";